import { cx } from 'class-variance-authority';
const title = cx('headings-title-t1 text-primary');
const description = cx('body-paragraph-lg text-secondary');
const overlay = cx('bg-blackA3 data-[state=open]:animate-overlayShow fixed inset-0');
const content = cx('bg-modal p-400 rounded-3xl flex flex-col gap-250 z-50', 'data-[state=open]:animate-dialogContentShow fixed top-1/2 md:top-[30%] left-1/2 max-h-[85vh] w-[90vw] max-w-[450px] -translate-x-1/2 -translate-y-1/2', 'outline-none', 'shadow-lg');
const close = cx('absolute top-200 right-200');
const inputGroup = cx('flex md:gap-100 items-center justify-stretch w-full');
export const styles = {
    content,
    overlay,
    close,
    title,
    description,
    inputGroup,
};
